// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2L22 2V8L2 8L2 2ZM2 10L22 10L22 22L2 22L2 10Z"}}]};

const HorizontalFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'horizontal-filled',
    ref,
    icon: element,
  },
));

HorizontalFilledIcon.displayName = 'HorizontalFilledIcon';

export default HorizontalFilledIcon;
